/* eslint-disable no-undef */
import React, { Component } from 'react';
import { Modal, Input, Form, message } from 'antd';

import { request } from '../../../SurveyStatistics/controller';

const { Item } = Form;


let shortNameApi;
function changeAPI() {
  const env = document.querySelector('meta[name=x-server-env]').content || 'test';
  if (env === 'production') {
    shortNameApi = '//gateway.api.xiaoyuanhao.com/contacts';
  } else {
    shortNameApi = '//aly-test.api.xiaoyuanhao.com/cloud-contacts-test';
  }
}

changeAPI();

class NickNameModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      name: '',
    }
  }

  handleOk = () => {
    const { form, onOk} = this.props;
    const { validateFields } = form;
    validateFields((error, {nickname=''}) => {
      if(!error) {
        request({
          url: `//${shortNameApi}/org/pc/shortName/set`,
          method: 'post',
          params: {
            shortName: nickname,
          },
        }).then(res => {
          if(res === 'success') {
            message.success('设置成功');
            onOk(nickname);
          }
        })
      }
    })
  }

  handleCancel = () => {

  }

  render() {
    // const { name } = this.state;
    const { onCancel, form, shortName } = this.props;
    const { getFieldProps } = form;
    return (
      <Modal
        title="简称设置"
        visible
        centered
        closable
        onOk={this.handleOk}
        onCancel={onCancel}
      >
        <Form horizontal>
          <Item
            label="简称"
            className={`form-edit-nickname ${shortName.length > 5 && 'error'}`}
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 17 }}
          >
            <Input
              suffix={`${shortName.length || 0}/5`}
              placeholder="请输入简称"
              {...getFieldProps('nickname', {
                initialValue: shortName,
                rules: [
                  { required: true, message: '请输入简称' },
                  { max: 5, message: '简称最大长度不能超过5个字符' },
                  {
                    pattern: /^[^\s]*$/,
                    message: '禁止输入空格',
                  },
                ],
              })}
            />
          </Item>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(NickNameModal);
